export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11503.368babb0.jpg";